import {Routes, Route} from 'react-router-dom'
// Pages générales
import About from './Pages/About/About';
import Home from "./Pages/Home/Home";
import SommaireTest from './Pages/Sommaire/SommaireTest';
import Majlist from './Pages/Maj/Maj';
// Tests CPC
import TestBombJackExtraSugarEdition from './Pages/Tests/TestsCPC/BombJackExtraSugarEdition';

//----------------------------------------------------------------------------------------------------------
export default function RoutesList()
    {
        return(
            <Routes>

                <Route path="/" element={<Home/>} />
                <Route path="/About" element={<About/>} />
                <Route path="/SommaireTest" element={<SommaireTest/>} />
                <Route path="/Majlist" element={<Majlist/>} />
                {/*TESTS CPC*/}
                <Route path="/TestBombJackExtraSugarEdition" element={<TestBombJackExtraSugarEdition/>} />

            </Routes>
        )
    }